import styled from "styled-components";
import { Helmet } from "react-helmet";
import { Table } from "react-bootstrap";
import config from "../styles";

const S = {
	Logo: styled.img`
      margin: auto;
      display: block;
      height: 40px;
      margin-bottom: 20px;
    `,
	Heading: styled.div`
      margin-bottom: 24px;
    `,
	TBody: styled.tbody`
      * td {
        width: 25%;
        line-height: 1;
        padding: 6px 0;
        margin: 0;
      }
    `,
	FirstCol: styled.td`
      color: ${config.colors.primary};
      font-weight: bold;
    `,
	Header: styled.h1<{ primary?: boolean; fontSize?: number }>`
      height: 40px;
      word-wrap: anywhere;
      color: ${({ primary }) => (primary ? config.colors.primary : config.colors.gray)};
      font-weight: bold;
      font-size: ${({ fontSize }) => fontSize ?? config.fontSizes.default}px;
    `,
};

interface ExtraRow {
	label: string;
	value: string | number;
}

interface AbstractReportHeadingProps {
	fileName: string;
	leftTitle: string;
	rightTitle?: string;
	date: string;
	refValue: string | number;
	subject: string;
	extraRows?: ExtraRow[];
	logo?: string;
}

const AbstractReportHeading = ({
	fileName,
	leftTitle,
	rightTitle,
	date,
	refValue,
	subject,
	extraRows = [],
	logo = "/logo.png",
}: AbstractReportHeadingProps) => (
	<S.Heading>
		<Helmet>
			<title>
				{fileName} - {leftTitle} - DIGITPOL
			</title>
		</Helmet>
		<S.Logo src={logo} alt="" />
		<Table size="sm" borderless>
			<S.TBody>
				<tr>
					<td colSpan={rightTitle ? 2 : 4}>
						<S.Header primary fontSize={config.fontSizes.large}>
							{fileName}
						</S.Header>
					</td>
					<td colSpan={rightTitle ? 2 : 0}>
						<S.Header>{rightTitle}</S.Header>
					</td>
				</tr>
				<tr>
					<S.FirstCol>Date</S.FirstCol>
					<td colSpan={3}>{date}</td>
				</tr>
				<tr>
					<S.FirstCol>Our Ref</S.FirstCol>
					<td colSpan={3}>{refValue}</td>
				</tr>
				<tr style={{ borderBottom: "1px black solid" }}>
					<S.FirstCol>Subject</S.FirstCol>
					<td colSpan={3}>{subject}</td>
				</tr>
				{extraRows.map(({ label, value }) => (
					<tr key={label}>
						<S.FirstCol>{label}</S.FirstCol>
						<td colSpan={3}>{value}</td>
					</tr>
				))}
				{/* Empty row to align all other rows */}
				<tr style={{ height: 0 }}>
					<td />
					<td />
					<td />
					<td />
				</tr>
			</S.TBody>
		</Table>
	</S.Heading>
);

export default AbstractReportHeading;
